<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    大新站<br>
站点介绍<br>
车站位于前海路与桃园路交叉口, 桃园路路下,呈东西走向布置。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:01	23:26	1号线	2分钟	4分40秒<br>
机场东	06:08	23:42	1号线	2分钟	4分40秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:17	23:25	1号线	3分45秒	5分45秒<br>
机场东	06:31	23:41	1号线	3分45秒	5分45秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:17	00:25	1号线	3分45秒	5分45秒<br>
机场东	06:31	00:41	1号线	3分45秒	5分45秒<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
前海路东侧、南新路、大新小学、南头街道办事处、关口下街、大新新村、一甲海边新村、大新社区工作站、中国邮政<br><br>
B出入口:<br>
前海路西侧（北）、前海小学、前海花园、南山区机关幼儿园<br><br>
C1出入口:<br>
桃园路南侧(西）、月亮湾大道、桃李花园、港湾丽都住宅小区、椰风海岸、深圳南山前海学校<br><br>
C2出入口:<br>
前海路西侧（南）、深圳西火车站、新德家园、南岗商务大厦、御海新苑、云栖西岸阁、天朗风清、阳光棕榈园、绿海名都<br><br>
D出入口:<br>
桃园路南侧（东)、大新村、金桃园大厦、国兴大厦、东方银座公馆<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 大新小学<br>
42、201、223、M343、M349、M364、M370、M375、M483、M484、M507、M518、高峰专线122号<br><br>
B出入口:<br>
公交站名： 前海花园<br>
M562、M176、M343、M349<br><br>
C2出入口:<br>
公交站名： 大新村<br>
36、42、58、M364、M375、M463、M483、M484、M492、M507、M518<br><br>
D出入口:<br>
公交站名： 大新地铁站<br>
36、58、201、223、M562、M176、M343、M349、M463、M492<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "yihaoxian",
          title: "1号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>





